
import React from "react";
import { P } from "@/components/ui/typography";
import { EmptyState } from "@/components/ui/empty-state";

interface EmptyMovieListProps {
  emptyMessage: string | React.ReactNode;
  isAuthenticated?: boolean;
}

const EmptyMovieList: React.FC<EmptyMovieListProps> = ({ 
  emptyMessage,
  isAuthenticated = false 
}) => {
  // Use the context variant based on authentication status
  const contextVariant = isAuthenticated ? "authenticated" : "unauthenticated";

  return (
    <EmptyState context={contextVariant} className="mt-1 md:mt-2">
      {typeof emptyMessage === 'string' ? (
        <P size="h4" variant="muted" className="text-sm md:text-base">
          {emptyMessage}
        </P>
      ) : (
        emptyMessage
      )}
    </EmptyState>
  );
};

export default EmptyMovieList;
